











































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { SelectItemString } from "@/types";
import { BaseMedicalSpecificationDoctor } from "@/components/medicalTypes/types";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: { EditDayChangePicker, NumberInput }
})
export default class BasicInfo8 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() list_marks_codes!: SelectItemString[]; //点数表コード
  @Prop() prefectures_strings!: SelectItemString[]; //都道府県コード（string版）

  divSelectItems: SelectItemString[] = [];
  prefectureSelectItems: SelectItemString[] = [];
  doctors: BaseMedicalSpecificationDoctor[] = [];

  mounted() {
    this.divSelectItems = [{ text: "", value: "", disp: "" }].concat(
      this.list_marks_codes
    );

    this.prefectureSelectItems = [{ text: "", value: "", disp: "" }].concat(
      this.prefectures_strings
    );

    this.tab.doctor_recs.forEach(d => {
      const doctor = this.newDoctor(
        this.tab.id,
        this.tab.patient_id,
        this.tab.office_id,
        this.tab.yearmonth
      );

      doctor.medical_org_name = d.medical_org_name;
      doctor.medical_org_short_name = d.medical_org_short_name;
      doctor.medical_org_pref = d.medical_org_pref;
      doctor.medical_org_div = d.medical_org_div;
      doctor.medical_org_code = d.medical_org_code;
      doctor.doctor_name = d.doctor_name;
      doctor.doctor_report_date = this.formatDate(d.doctor_report_date);

      this.doctors.push(doctor);
    });

    while (this.doctors.length < 4) {
      this.doctors.push(
        this.newDoctor(
          this.tab.id,
          this.tab.patient_id,
          this.tab.office_id,
          this.tab.yearmonth
        )
      );
    }
  }

  private newDoctor = (
    medicalSpecificationId: number,
    patientId: number,
    officeId: number,
    yearmonth: string
  ): BaseMedicalSpecificationDoctor => {
    return {
      id: 0,
      medical_specification_id: medicalSpecificationId,
      patient_id: patientId,
      office_id: officeId,
      yearmonth: yearmonth,
      medical_org_name: "",
      medical_org_short_name: "",
      medical_org_pref: "",
      medical_org_div: "",
      medical_org_code: "",
      doctor_name: "",
      doctor_report_date: "",
      created_at: null,
      updated_at: null,
      deleted_at: null
    };
  };

  @Watch("doctors", { deep: true })
  private onDoctorsChanged(doctors: BaseMedicalSpecificationDoctor[]) {
    this.tab.medical_org_name = "";
    this.tab.medical_org_pref = "";
    this.tab.medical_org_div = "";
    this.tab.medical_org_code = "";
    this.tab.doctor_name = "";
    this.tab.doctor_report_date = null;
    this.tab.doctor_report_date_str = "";
    this.tab.doctor_recs = [];

    doctors
      .filter(d => this.hasValue(d))
      .forEach(d => {
        this.tab.doctor_recs.push({
          id: 0,
          medical_specification_id: this.tab.id,
          patient_id: this.tab.patient_id,
          office_id: this.tab.office_id,
          yearmonth: this.tab.yearmonth,
          medical_org_name: d.medical_org_name,
          medical_org_short_name: d.medical_org_short_name,
          medical_org_pref: d.medical_org_pref,
          medical_org_div: d.medical_org_div,
          medical_org_code: d.medical_org_code,
          doctor_name: d.doctor_name,
          doctor_report_date: this.formatISO8601(d.doctor_report_date),
          created_at: null,
          updated_at: null,
          deleted_at: null
        });
      });

    if (this.tab.doctor_recs.length > 0) {
      //最後の主治医を月末最終時点の指示書の主治医とみなす
      const d = this.tab.doctor_recs.slice(-1)[0];
      this.tab.medical_org_name = d.medical_org_name;
      this.tab.medical_org_pref = d.medical_org_pref;
      this.tab.medical_org_div = d.medical_org_div;
      this.tab.medical_org_code = d.medical_org_code;
      this.tab.doctor_name = d.doctor_name;
      this.tab.doctor_report_date = this.formatISO8601(d.doctor_report_date);
      this.tab.doctor_report_date_str = d.doctor_report_date ?? "";
    }
  }

  private hasValue = (d: BaseMedicalSpecificationDoctor): boolean => {
    if (d.medical_org_name) return true;
    // if (d.medical_org_short_name) return true; //値の有無の判定に使用しない
    if (d.medical_org_pref) return true;
    if (d.medical_org_div) return true;
    if (d.medical_org_code) return true;
    if (d.doctor_name) return true;
    if (d.doctor_report_date) return true;
    return false;
  };

  // ISO-8601 の日付文字列を YYYY-MM-DD の形式にフォーマット
  private formatDate = (s: string | null): string => {
    if (!s) return "";

    const d = new Date(s);
    const yyyy = d.getFullYear().toString();
    const mm = ("0" + (d.getMonth() + 1)).slice(-2);
    const dd = ("0" + d.getDate()).slice(-2);
    return `${yyyy}-${mm}-${dd}`;
  };

  // YYYY-MM-DD の形式の日付文字列を ISO-8601 にフォーマット
  private formatISO8601 = (s: string | null): string => {
    if (!s) return "";

    const d = new Date(s);
    const yyyy = d.getFullYear().toString();
    const mm = ("0" + (d.getMonth() + 1)).slice(-2);
    const dd = ("0" + d.getDate()).slice(-2);
    return `${yyyy}-${mm}-${dd}T00:00:00+09:00`;
  };
}
